export default [
  {
    path: '/404',
    name: 'not-found',
    meta: { publicPage: true },
    component: () =>
      import(/* webpackChunkName: "notFound" */ '@/views/NotFound.vue')
  },
  {
    path: '/403',
    meta: { publicPage: true },
    name: 'denied',
    component: () =>
      import(/* webpackChunkName: "accessDenied" */ '@/views/Deny.vue')
  },
  {
    path: '*',
    meta: { publicPage: true },
    redirect: {
      path: '/404'
    }
  },
]
